import { useBaseApiMutation } from "@mutation/baseMutation";


export const useAccountPostMutation = () => {

    return useBaseApiMutation({
        method:"POST",
        endpoint:"/organization/me"
    })
}


export const useAdminAccountUpdateMutation = () => {

    return useBaseApiMutation({
        method:"PUT",
        endpoint: `/organization/me/account/{account_uuid}`
    })
}

export const useAccountUpdateMutation = () => {

    return useBaseApiMutation({
        method:"PUT",
        endpoint: `/account/me`
    })
}


// /api/v1/organization/me/member/{account_uuid}/update

export const useAccountMemberUpdateMutation = () =>{
    return useBaseApiMutation({
        method:"PUT",
        endpoint: `/organization/me/member/{account_uuid}/update`
    })
}